import {
  buildLogoutCookies,
  COOKIE_OAUTH_STATE,
  COOKIE_REFRESH_TOKEN,
  COOKIE_SESSION,
} from '../session/cookies.js';
import type { LogoutResult, ResolvedConfig } from '../types.js';

export function buildLogout(_config: ResolvedConfig): LogoutResult {
  return {
    cookiesToClear: [COOKIE_SESSION, COOKIE_REFRESH_TOKEN, COOKIE_OAUTH_STATE],
  };
}

export { buildLogoutCookies };
